<template>
    <Row :gutter="10">
        <Col span="6" v-for="elem in list" :key="elem.id">
            <div class="user-info-box" >
                <Avatar style="width: 32px;height: 32px;" :src="elem.head_url ?elem.head_url :'https://static.diantiyun.com/upload/image/avatar.png?a=2'"/>
                <div class="user-realname-mobile ">
                    <div>{{elem.realname}}</div>
                </div>
                <div class="operate-btn">
                    <!---->
                    <res-view :keyName="'fun_user_update'">
                        <Icon @click="onSelectUser('edit',elem)" type="ios-create" style="cursor: pointer;" size="22" color="#3399ff"/>
                    </res-view>
                    <res-view :keyName="'fun_user_delete'">
                        <Icon @click="onSelectUser('delete',elem)" type="md-trash" style="cursor: pointer;" size="20" color="#d81e06"/>
                    </res-view>
                </div>
            </div>
        </Col>
        <!-- 用户菜单 -->
    </Row>
</template>

<script>
    import ResView from "../../my-components/res-view";
    export default {
        name: "user-list",
        components:{ResView},
        props: {
            list: Array
        },
        data() {
            return {
                contextMenu: {
                    currentObj: null,
                    show: false,
                    position: {
                        x: 0,
                        y: 0
                    },
                    menus: [
                        {
                            icon: 'ios-create-outline',
                            text: 'l.property',
                            callback: 'preEdit',
                            show: true
                        },
                        {
                            icon: 'ios-close',
                            text: 'l.delete',
                            callback: 'deleteDept',
                            show: true
                        }
                    ]
                },
            }
        },
        methods: {
            onSelectUser(name, user) {
                this.$emit(`on-${name}`, user)
            },
        },

    }
</script>

<style scoped lang="less">
    li {
        margin: 5px 0;
    }

    .user-info-box{
        display: flex;
        align-items: center;
        box-shadow: 0px 2px 8px gainsboro;
        padding: 5px 10px;
        justify-content: space-around;
    }
    .user-realname-mobile {
        display: flex;
        width: 60%;
        margin-left: 5px;
    }

    .user-realname-mobile > div:nth-child(1) {
        max-width: 130px;
        overflow-x: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .user-realname-mobile:hover {
        cursor: pointer;
    }
    .operate-btn{
        display: flex;
        align-items: center;
    }

</style>